// eslint-disable-next-line import/no-extraneous-dependencies, import/named
import { ZodTypeAny, z } from 'zod'

export const intersect = (schemas: ZodTypeAny[]) =>
  schemas.reduce(
    (buffer: ZodTypeAny, schema: ZodTypeAny) => z.intersection(buffer, schema),
    z.object({})
  )
